<template>
  <div class="zm-breadcrumb" aria-label="Breadcrumb" role="navigation">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ZmBreadcrumb',

    props: {
      separator: {
        type: String,
        default: '/'
      },
      separatorClass: {
        type: String,
        default: ''
      }
    },

    provide() {
      return {
        ZmBreadcrumb: this
      };
    },

    mounted() {
      const items = this.$el.querySelectorAll('.zm-breadcrumb__item');
      if (items.length) {
        items[items.length - 1].setAttribute('aria-current', 'page');
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/mixins/utils";
  @import "../../scss/common/var";

  @include b(breadcrumb) {
    font-size: 14px;
    line-height: 20px;
    @include utils-clearfix;

    @include e(separator) {
      margin: 0 8px;
      font-weight: bold;
      // color: $--color-text-placeholder;

      &[class*=icon] {
        margin: 0 6px;
        font-weight: normal;
        font-size: 12px;
      }
    }
  }
</style>
